import { RcButton, styled } from '@ringcentral/juno';

export const ActionButton = styled(RcButton)`
  &:last-child {
    margin-left: 10px;
  }
`;
